/* PawerLab — Cart page behaviour
   Loaded only on /cart, alongside pawer-cart-drawer.js (which is loaded
   site-wide from header.liquid).

   Adapted from reference/cart-ref/assets/pawerlab-cart.js. Quantity
   changes go through the Cart AJAX API *with* the Section Rendering
   API, so Shopify re-renders the real Liquid for us — discounts,
   per-line savings, the shipping bar, and the cross-sell all stay
   correct without duplicating any money/discount logic in JS.

   The page works with JavaScript off: quantity inputs are real
   updates[key] fields inside a form that posts to /cart, and Checkout
   is a real submit button. This file only upgrades that. */

(function () {
  'use strict';

  var page = document.querySelector('[data-cart-page]');
  if (!page) return;

  var SECTION_ID = page.dataset.sectionId;
  var XS = document.querySelector('[data-cart-xs]');
  var XS_ID = XS ? XS.dataset.sectionId : null;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var manual = document.querySelector('[data-manual-update]');
  if (manual) manual.hidden = true;

  /* ---------- helpers ---------- */

  function busy(line, state) {
    var el = document.querySelector('.cartline[data-line="' + line + '"]');
    if (el) el.dataset.busy = state ? 'true' : 'false';
  }

  function swap(html, selector) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector(selector);
    var live = document.querySelector(selector);

    if (fresh && live) {
      live.replaceWith(fresh);
    } else if (!fresh && live) {
      live.remove();
    }
  }

  function sectionList() {
    return XS_ID ? SECTION_ID + ',' + XS_ID : SECTION_ID;
  }

  function noteValue() {
    var t = document.getElementById('CartNote');
    return t ? t.value : null;
  }

  function restoreNote(value, wasOpen) {
    if (value === null) return;
    var t = document.getElementById('CartNote');
    if (!t) return;
    t.value = value;
    if (wasOpen) {
      var d = t.closest('details');
      if (d) d.open = true;
    }
  }

  /* ---------- the one request that does everything ---------- */

  function change(body, line) {
    if (line) busy(line, true);

    var note = noteValue();
    var noteOpen = !!document.querySelector('.cartnote[open]');

    body.sections = sectionList();
    body.sections_url = window.location.pathname;

    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status) throw new Error(cart.description || cart.message);

        if (cart.item_count === 0) { window.location.reload(); return; }

        var sections = cart.sections || {};
        swap(sections[SECTION_ID], '[data-cart-page]');
        if (XS_ID) swap(sections[XS_ID], '[data-cart-xs]');

        restoreNote(note, noteOpen);
        rebind();

        /* Keep the drawer + header badge in step without a second fetch.
           Routed through pawer-cart-drawer.js's own render() exclusively
           (not a duplicate direct textContent write here) — it's the one
           place that knows the desktop "(N)" text vs. the mobile icon
           badge need different formatting. */
        if (window.PawerLabCart && window.PawerLabCart.render) {
          try { window.PawerLabCart.render(cart); } catch (e) {}
        }
      })
      .catch(function (err) {
        if (line) busy(line, false);
        console.error('[PawerLab] cart update failed:', err);
        window.location.assign(root + 'cart');
      });
  }

  /* ---------- interactions ---------- */

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-step]');
    if (step && step.closest('[data-cart-page]')) {
      e.preventDefault();
      var input = document.querySelector('[data-qty-input][data-line="' + step.dataset.line + '"]');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 0) + parseInt(step.dataset.step, 10);
      if (next < 0) next = 0;
      input.value = next;
      change({ line: parseInt(step.dataset.line, 10), quantity: next }, step.dataset.line);
      return;
    }

    var rm = e.target.closest('[data-remove]');
    if (rm && rm.closest('[data-cart-page]')) {
      e.preventDefault();
      change({ line: parseInt(rm.dataset.line, 10), quantity: 0 }, rm.dataset.line);
    }

    /* Subscription upgrade/downgrade — same cart/change.js selling_plan
       mechanism as the drawer (pawer-cart-drawer.js), routed through
       this page's own change() so it gets the Section Rendering API
       swap (real per-line savings, plan name, etc. all come from fresh
       Liquid) instead of a manual DOM patch. The buttons themselves are
       server-rendered in pawer-cart-main.liquid, since this page —
       unlike the drawer — has direct Liquid access to
       item.product.selling_plan_groups and doesn't need an async check. */
    var upBtn = e.target.closest('[data-upgrade-sub]');
    var downBtn = e.target.closest('[data-downgrade-sub]');
    var subBtn = upBtn || downBtn;
    if (subBtn && subBtn.closest('[data-cart-page]')) {
      e.preventDefault();
      var subLine = parseInt(subBtn.dataset.line, 10);
      change({ line: subLine, selling_plan: upBtn ? upBtn.dataset.upgradeSub : null }, subLine);
    }
  });

  var timer;
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input || !input.closest('[data-cart-page]')) return;

    clearTimeout(timer);
    timer = setTimeout(function () {
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      change({ line: parseInt(input.dataset.line, 10), quantity: qty }, input.dataset.line);
    }, 550);
  });

  function bindNote() {
    var t = document.getElementById('CartNote');
    if (!t || t.dataset.bound) return;
    t.dataset.bound = '1';
    t.addEventListener('change', function () {
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: t.value })
      }).catch(function () {});
    });
  }

  function rebind() {
    var m = document.querySelector('[data-manual-update]');
    if (m) m.hidden = true;
    bindNote();
  }

  bindNote();

  /* Re-render without mutating the cart — used after an add-to-cart
     from the drawer, where the cart already changed and this page only
     needs fresh Liquid. GET is the right verb: change.js would need a
     line/quantity this call has no reason to touch. */
  function reload() {
    var was = document.querySelectorAll('.cartline').length;

    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionList()), {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        swap(sections[SECTION_ID], '[data-cart-page]');
        if (XS_ID) swap(sections[XS_ID], '[data-cart-xs]');
        rebind();

        var lines = document.querySelectorAll('.cartline');
        if (lines.length > was && lines[lines.length - 1]) {
          lines[lines.length - 1].scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      })
      .catch(function (err) { console.error('[PawerLab] cart page reload failed:', err); });
  }

  /* pawer-cart-drawer.js calls this after an add-to-cart so the lines
     on this page don't go stale if the cart page is open in another
     tab, or the shopper adds from a cross-sell card while already
     viewing /cart. */
  window.PawerLabCartPage = { reload: reload };
})();
